import styled from 'styled-components';

export const MasterCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  margin: auto 5px auto 10px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  & > label {
    display: block;
    margin: auto 8px auto 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 10px;

  .right {
    margin-left: auto;
  }

  @media (max-width: 500px) {
    display: block;

    button {
      margin-bottom: 5px;
    }
  }
`;

export const Table = styled.table`
  font-size: 13px;
  min-width: 600px;
  width: 100%;
`;

export const TBody = styled.tbody`
  td {
    padding: 6px 3px 6px 0px;
  }

  td.check {
    padding: 0px;
    text-align: center;
    width: 32px;
  }

  td.nowrap {
    white-space: nowrap;
  }
`;

export const TRBody = styled.tr`
  :nth-child(odd) {
    background-color: #e7e7e7;
  }

  svg {
    display: initial;
    font-size: 11px;
    transform: scale(-1, 1);
  }

  svg.like {
    color: #83cb20;
  }

  svg.dislike {
    color: #e51f25;
  }
`;

export const THead = styled.thead`
  tr {
    background-color: #01509c !important;
    color: #fff;
  }

  th {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
  }

  th:first-child {
    border-top-left-radius: 10px;
    min-width: 10px;
  }

  th:last-child {
    border-top-right-radius: 10px;
    min-width: 10px;
  }
`;

export const TFoot = styled.tfoot`
  tr {
    background-color: #01509c !important;
    color: #fff;
  }

  td {
    border-radius: 0px 0px 0px 0px;
  }

  .MuiToolbar-root {
    min-height: 35px;
    color: #fff;
  }

  .MuiSelect-icon {
    color: #fff;
  }

  .MuiIconButton-root {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;

export const MessageTD = styled.td.attrs({
  colSpan: 10
})`
  background-color: #fff !important;
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
`;

export const Dot = styled.span`
  height: 6px;
  width: 6px;
  background-color: ${props => props.color};
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
`;

export const GridContainer = styled.div`
  overflow: auto;
`;
